/* tslint:disable */
import { Injectable } from '@angular/core';
import { User } from '../../models/User';
import { AccessToken } from '../../models/AccessToken';
import { ACL } from '../../models/ACL';
import { RoleMapping } from '../../models/RoleMapping';
import { Role } from '../../models/Role';
import { RootAccount } from '../../models/RootAccount';
import { ChartOfAccount } from '../../models/ChartOfAccount';
import { UserProfile } from '../../models/UserProfile';
import { CompanyAsset } from '../../models/CompanyAsset';
import { CompanyAccount } from '../../models/CompanyAccount';
import { AppProperties } from '../../models/AppProperties';
import { PropertyUnits } from '../../models/PropertyUnits';
import { PropertyType } from '../../models/PropertyType';
import { Country } from '../../models/Country';
import { PropertyBank } from '../../models/PropertyBank';
import { Banking } from '../../models/Banking';
import { PropertyOwner } from '../../models/PropertyOwner';
import { PropertyCaretaker } from '../../models/PropertyCaretaker';
import { ManagementFeeSettings } from '../../models/ManagementFeeSettings';
import { StorageSettings } from '../../models/StorageSettings';
import { TenantUnit } from '../../models/TenantUnit';
import { PropertyPropertyType } from '../../models/PropertyPropertyType';
import { PropertyDetails } from '../../models/PropertyDetails';
import { MeterReading } from '../../models/MeterReading';
import { UnitFeature } from '../../models/UnitFeature';
import { PropertyUnitFeature } from '../../models/PropertyUnitFeature';
import { CheckList } from '../../models/CheckList';
import { TenantCheckList } from '../../models/TenantCheckList';
import { FileStorage } from '../../models/FileStorage';
import { FileManager } from '../../models/FileManager';
import { Lease } from '../../models/Lease';
import { IncomeInvoice } from '../../models/IncomeInvoice';
import { PaymentMethods } from '../../models/PaymentMethods';
import { TenantDeposit } from '../../models/TenantDeposit';
import { PropertyFile } from '../../models/PropertyFile';
import { PropertyUnitFile } from '../../models/PropertyUnitFile';
import { ProfileFile } from '../../models/ProfileFile';
import { SettingsTenant } from '../../models/SettingsTenant';
import { VendorCategories } from '../../models/VendorCategories';
import { WorkOrder } from '../../models/WorkOrder';
import { HouseInspection } from '../../models/HouseInspection';
import { InspectionRoom } from '../../models/InspectionRoom';
import { InspectionFile } from '../../models/InspectionFile';
import { IncomeExpenditure } from '../../models/IncomeExpenditure';
import { TenantLease } from '../../models/TenantLease';
import { Expenditure } from '../../models/Expenditure';
import { LeaseArchive } from '../../models/LeaseArchive';
import { WorkOrderExpenses } from '../../models/WorkOrderExpenses';
import { DepositType } from '../../models/DepositType';
import { Fee } from '../../models/Fee';
import { TenantFee } from '../../models/TenantFee';
import { VendorPayments } from '../../models/VendorPayments';
import { BillsPayments } from '../../models/BillsPayments';
import { RecurringCharge } from '../../models/RecurringCharge';
import { LandlordDetails } from '../../models/LandlordDetails';
import { LandlordProperties } from '../../models/LandlordProperties';
import { TempLeaseRenewal } from '../../models/TempLeaseRenewal';
import { Reference } from '../../models/Reference';
import { CreditNote } from '../../models/CreditNote';
import { PropertyEvents } from '../../models/PropertyEvents';
import { VerificationCode } from '../../models/VerificationCode';
import { TenantExitTemp } from '../../models/TenantExitTemp';
import { LandlordPayout } from '../../models/LandlordPayout';
import { RequisiteCosts } from '../../models/RequisiteCosts';
import { RemittanceReportSettings } from '../../models/RemittanceReportSettings';
import { PaymentEntries } from '../../models/PaymentEntries';
import { TenantPayments } from '../../models/TenantPayments';
import { InvoicePaymentEntry } from '../../models/InvoicePaymentEntry';
import { IncomeInvoiceEditMemo } from '../../models/IncomeInvoiceEditMemo';
import { PaymentReversalMemo } from '../../models/PaymentReversalMemo';
import { PropertySettlement } from '../../models/PropertySettlement';
import { TenantLeaseEventsModel } from '../../models/TenantLeaseEventsModel';
import { InvoiceRefund } from '../../models/InvoiceRefund';
import { LeaseTermination } from '../../models/LeaseTermination';
import { LeaseRenewTemp } from '../../models/LeaseRenewTemp';
import { PropertyBadDebt } from '../../models/PropertyBadDebt';
import { MeterReadingEntry } from '../../models/MeterReadingEntry';
import { PropertyBills } from '../../models/PropertyBills';
import { PropertyBillsEditMemo } from '../../models/PropertyBillsEditMemo';
import { LeaseReviewHistory } from '../../models/LeaseReviewHistory';
import { Discount } from '../../models/Discount';
import { LandlordChartOfAccount } from '../../models/LandlordChartOfAccount';
import { DigitaxActions } from '../../models/DigitaxActions';
import { BulkSMS } from '../../models/BulkSMS';
import { BulkSMSRecipient } from '../../models/BulkSMSRecipient';

export interface Models { [name: string]: any }

@Injectable()
export class SDKModels {

  private models: Models = {
    User: User,
    AccessToken: AccessToken,
    ACL: ACL,
    RoleMapping: RoleMapping,
    Role: Role,
    RootAccount: RootAccount,
    ChartOfAccount: ChartOfAccount,
    UserProfile: UserProfile,
    CompanyAsset: CompanyAsset,
    CompanyAccount: CompanyAccount,
    AppProperties: AppProperties,
    PropertyUnits: PropertyUnits,
    PropertyType: PropertyType,
    Country: Country,
    PropertyBank: PropertyBank,
    Banking: Banking,
    PropertyOwner: PropertyOwner,
    PropertyCaretaker: PropertyCaretaker,
    ManagementFeeSettings: ManagementFeeSettings,
    StorageSettings: StorageSettings,
    TenantUnit: TenantUnit,
    PropertyPropertyType: PropertyPropertyType,
    PropertyDetails: PropertyDetails,
    MeterReading: MeterReading,
    UnitFeature: UnitFeature,
    PropertyUnitFeature: PropertyUnitFeature,
    CheckList: CheckList,
    TenantCheckList: TenantCheckList,
    FileStorage: FileStorage,
    FileManager: FileManager,
    Lease: Lease,
    IncomeInvoice: IncomeInvoice,
    PaymentMethods: PaymentMethods,
    TenantDeposit: TenantDeposit,
    PropertyFile: PropertyFile,
    PropertyUnitFile: PropertyUnitFile,
    ProfileFile: ProfileFile,
    SettingsTenant: SettingsTenant,
    VendorCategories: VendorCategories,
    WorkOrder: WorkOrder,
    HouseInspection: HouseInspection,
    InspectionRoom: InspectionRoom,
    InspectionFile: InspectionFile,
    IncomeExpenditure: IncomeExpenditure,
    TenantLease: TenantLease,
    Expenditure: Expenditure,
    LeaseArchive: LeaseArchive,
    WorkOrderExpenses: WorkOrderExpenses,
    DepositType: DepositType,
    Fee: Fee,
    TenantFee: TenantFee,
    VendorPayments: VendorPayments,
    BillsPayments: BillsPayments,
    RecurringCharge: RecurringCharge,
    LandlordDetails: LandlordDetails,
    LandlordProperties: LandlordProperties,
    TempLeaseRenewal: TempLeaseRenewal,
    Reference: Reference,
    CreditNote: CreditNote,
    PropertyEvents: PropertyEvents,
    VerificationCode: VerificationCode,
    TenantExitTemp: TenantExitTemp,
    LandlordPayout: LandlordPayout,
    RequisiteCosts: RequisiteCosts,
    RemittanceReportSettings: RemittanceReportSettings,
    PaymentEntries: PaymentEntries,
    TenantPayments: TenantPayments,
    InvoicePaymentEntry: InvoicePaymentEntry,
    IncomeInvoiceEditMemo: IncomeInvoiceEditMemo,
    PaymentReversalMemo: PaymentReversalMemo,
    PropertySettlement: PropertySettlement,
    TenantLeaseEventsModel: TenantLeaseEventsModel,
    InvoiceRefund: InvoiceRefund,
    LeaseTermination: LeaseTermination,
    LeaseRenewTemp: LeaseRenewTemp,
    PropertyBadDebt: PropertyBadDebt,
    MeterReadingEntry: MeterReadingEntry,
    PropertyBills: PropertyBills,
    PropertyBillsEditMemo: PropertyBillsEditMemo,
    LeaseReviewHistory: LeaseReviewHistory,
    Discount: Discount,
    LandlordChartOfAccount: LandlordChartOfAccount,
    DigitaxActions: DigitaxActions,
    BulkSMS: BulkSMS,
    BulkSMSRecipient: BulkSMSRecipient,
    
  };

  public get(modelName: string): any {
    return this.models[modelName];
  }

  public getAll(): Models {
    return this.models;
  }

  public getModelNames(): string[] {
    return Object.keys(this.models);
  }
}
